import '../helpers/FileDrop.css';
import { useState } from 'react';
import { getText } from '../../i18n';

export function FileDrop({ file, onChange }) {
    const reader = new FileReader();
    const [fileProgress, setFileProgress] = useState(0);
    const [fileInProgress, setFileInProgress] = useState(false);

    const drop = event => {
        event.preventDefault();
        const newFile = event.dataTransfer.files[0];
        readFile(newFile);
        onChange(newFile);
    };

    const uploadFile = event => {
        event.preventDefault();
        const newFile = event.target.files[0];
        readFile(newFile);
        onChange(newFile);
    };

    const handleFileProgress = event => {
        const percent = Math.round((event.loaded / event.total) * 100);
        setFileProgress(percent);
        setFileInProgress(percent !== 0 && percent !== 100);
    };

    const readFile = file => {
        reader.addEventListener('progress', event => handleFileProgress(event));
        reader.readAsBinaryString(file);
        reader.removeEventListener('progress', event =>
            handleFileProgress(event),
        );
    };

    return (
        <div
            onDrop={event => drop(event)}
            onDragOver={event => event.preventDefault()}
            className="form-file-drop"
        >
            {!file ? (
                <div className="form-file-drop-vertically-center">
                    <i className="bi bi-cloud-upload form-file-drop-horizontally-center" />
                    <input
                        type="file"
                        id="fileInput"
                        onChange={event => uploadFile(event)}
                        hidden
                    />
                    <label htmlFor="fileInput" className="form-file-drop-label">
                        {getText('msg_209bedbf6589')}{' '}
                        <span className="primary-blue-color">
                            <u>{getText('msg_2f3b5c55bc27')}</u>
                        </span>
                    </label>
                </div>
            ) : (
                <div className="form-file-dropped">
                    <div className="form-file-dropped-status">
                        {fileInProgress ? 'Uploading File' : 'File Selected'}
                    </div>
                    <div className="form-file-dropped-filename">
                        {file.name ?? ''}
                        <i
                            className="bi bi-x form-file-dropped-x-icon"
                            onClick={() => onChange(null)}
                        />
                    </div>
                    {fileInProgress && (
                        <progress
                            className="form-file-dropped-progress"
                            value={fileProgress}
                            max="100"
                        />
                    )}
                </div>
            )}
        </div>
    );
}
